import React from 'react'

export const IconCircleCheck = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <circle cx="11" cy="11" r="9" fill="currentColor" />
    <path
      d="M7.33334 11.4583L9.62501 13.75L15.5833 8.25"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
